export enum Visibility {
	VISIBLE = 'visible',
	HIDDEN = 'hidden'
}
